import script from "./passwordResetCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./passwordResetCheck.vue?vue&type=script&setup=true&lang=js"

import "./passwordResetCheck.vue?vue&type=style&index=0&id=17ff290c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ff290c"]])

export default __exports__